import addStylesheet from "@/utils/addStylesheet";
import { generateCSSFromConfig } from "@/utils/cssGenerator"
import { FILTERS } from "@/enum/Filters";

export default function enableContrast(contrast: string) {
    const filter = FILTERS[contrast];

    if (!filter) {
        // Remove styles if no contrast is set
        document.getElementById('cya11y-filter-style')?.remove();
        document.body.classList.remove('cya11y-filter', 'cya11y-dark-contrast');
        return;
    }

    const exclusions = ':not(#cya11y-container):not(#cya11y-container *):not(.cya11y-overlay):not(.cya11y-rg-container):not(.cya11y-rg-container *)';

    let css = generateCSSFromConfig({
        ...filter,
        selector: `*${filter.mainSelector}${exclusions}`,
    });

    // Exclusions sit on the reset tags themselves (subject position): as part
    // of a descendant selector they would be satisfied by any non-widget
    // ancestor (e.g. body) and leak into the widget's own UI.
    if (filter.backgroundResetSelectors?.length) {
        css += generateCSSFromConfig({
            styles: { 'background-color': 'transparent' },
            selector: filter.backgroundResetSelectors.map(tag => `${tag}${exclusions}`).join(','),
        });
    }

    addStylesheet({ css, id: 'cya11y-filter-style' });
    document.body.classList.add('cya11y-filter');
    document.body.classList.toggle('cya11y-dark-contrast', contrast === 'dark-contrast');
}